export enum AccountingReviewReportExportType {
    Order = 1,
    Payment = 2,
}

export const AccountingReviewReportExportTypeLabels: Record<
    AccountingReviewReportExportType,
    string
> = {
    [AccountingReviewReportExportType.Order]: 'Order',
    [AccountingReviewReportExportType.Payment]: 'Payment',
};
